const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M16.857 4a.75.75 0 0 0-1.5 0v3.201l-2.772-1.6a.75.75 0 1 0-.75 1.299l2.772 1.6-2.772 1.6a.75.75 0 0 0 .75 1.3l2.772-1.6V13a.75.75 0 0 0 1.5 0V9.799l2.772 1.6a.75.75 0 0 0 .75-1.298L17.607 8.5l2.772-1.6a.75.75 0 1 0-.75-1.3l-2.772 1.601zM5 20.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/></svg>';
export {
  a as w
};
